module.exports = __webpack_public_path__ + "img/logo-castellvi.493748a7.png";